




































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ajax from '@/lib/ajax';

@Component({
    name: 'MailboxCallback'
})
export default class MailboxCallback extends GiganautVue {
    success = false;
    error = '';
    email = '';

    async mounted() {
        await this.handleCallback();
    }

    async handleCallback() {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const errorParam = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        if (errorParam) {
            this.error = errorDescription || errorParam || 'Authorization was denied';
            return;
        }

        if (!code) {
            this.error = 'No authorization code received';
            return;
        }

        // Get the code verifier from session storage
        const codeVerifier = sessionStorage.getItem('mailbox_code_verifier');
        if (!codeVerifier) {
            this.error = 'Session expired. Please try connecting again.';
            return;
        }

        try {
            const redirectUri = window.location.origin + '/agency/userprofile/mailbox-callback';

            const response = await ajax.post('/api/v1/agency/users/profile/mailbox/callback', {
                authorizationCode: code,
                codeVerifier: codeVerifier,
                redirectUri: redirectUri
            });

            this.success = true;
            this.email = response.data.providerEmail || '';

            // Clean up
            sessionStorage.removeItem('mailbox_code_verifier');
        } catch (err: any) {
            this.error = err.response?.data?.message || err.message || 'Failed to complete connection';
        }
    }

    goBack() {
        this.$router.push('/agency/userprofile');
    }
}
